'use client'

import * as React from 'react'

interface BackgroundSectionProps {
  children: React.ReactNode
  className?: string
}

export function BackgroundSection({ children, className = '' }: BackgroundSectionProps) {
  return (
    <div
      className={`
        flex flex-col gap-24 py-20 md:py-24 lg:mx-12 lg:border-x overflow-hidden
        bg-[url('/marketing/about/about_light.svg')] bg-cover bg-center bg-no-repeat
        dark:bg-[url('/marketing/about/about_dark.svg')]
        ${className}
      `}
    >
      {children}
    </div>
  )
}
